/**
 * Terminus NavMenu Component v1.0.0
 */
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { interceptClickEvent as interceptClickEventUtil } from '../../util/click-interceptor';

import { ReactiveFormsModule } from '@angular/forms';
import { EntitlementsService } from 'entitlements';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { NavMenu } from './../../models/nav.model';

@Component({
  selector: 'tux-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    ReactiveFormsModule,
    ToggleSwitchModule,
  ],
})
export class NavMenuComponent {
  closeIcon = faClose;

  entitlementService = inject(EntitlementsService);

  @Input() menu: NavMenu;

  @Output() navMenuClosed: EventEmitter<void> = new EventEmitter<void>();

  interceptClickEvent($event: MouseEvent) {
    interceptClickEventUtil($event) && this.navMenuClosed.emit();
  }
}
